import Axios from 'axios'
import server from 'util/Server'
import { ConfigInicialPayload } from '../interfaces/ConfiguracionInicial.interfaces'
import { getEquiposByEmpresasID } from 'app/vistas/Configuracion/AsignacionParametros/services'
import { obtenerDatafonos } from 'app/vistas/Configuracion/GestionDatafonos/services/GestionDatafonos.services'

export const GetSurtidoresDetallesByEds = (edsId: number) => {
     return Axios.get(`${server.host!}7001/api/surtidor/configuracion-eds/${edsId}`, { headers: { Authorization: server.obtenerToken() } })
}

export const CrearConfiguracionInicial = (payload: ConfigInicialPayload) => {
    return Axios.post(
        `${server.host!}8014/api/v1/configuracion-inicial/crear`,
        payload,
        { headers: { Authorization: server.obtenerToken() } }
    )
}

export const GetEquiposByEds = (edsId: number) => getEquiposByEmpresasID(edsId)
export const GetDatafonosByEds = (edsId: string) => obtenerDatafonos(edsId)

export const GetListadoConfiguracionInicial = (edsId: string | number) =>
    Axios.get(`${server.host!}8014/api/v1/configuracion-inicial/listado`, { params: { eds_id: edsId }, headers: { Authorization: server.obtenerToken() } })

export const EliminarConfiguracionInicial = (payload: { configuracion_id: number; estado_inactivo_id: number }) =>
    Axios.post(`${server.host!}8014/api/v1/configuracion-inicial/eliminar`, payload, { headers: { Authorization: server.obtenerToken() } })

export const GetConfigDetalleConfiguracionInicial = (configuracionId: number) =>
    Axios.get(`${server.host!}8014/api/v1/configuracion-inicial/detalle`, 
        { 
            params: { configuracion_id: configuracionId }, 
            headers: { Authorization: server.obtenerToken() } 
        }
    )

export const EditarConfiguracionInicial = (payload: {
    configuracion_id: number
    numero_pantalla?: number
    estado_id?: number
    permitir_efectivo?: boolean
    inactividad_segundos?: number
    monto_minimo_programacion?: number
    tiempo_espera_pago?: number
    datafono_id?: number | null
}) =>  Axios.put(`${server.host!}8014/api/v1/configuracion-inicial/editar`, payload, { headers: { Authorization: server.obtenerToken() } })